'use client'

import { Divider } from '@/components/ui/divider'
import { TCollectionFormatted } from '@/types/collection'
import { useTranslations } from 'next-intl'
import { useCollectionStore } from '../../store/collection-store'
import { FilterList } from './filter-list'

export const FilterBar = ({
  collection,
}: {
  collection: TCollectionFormatted
}) => {
  const productCount = useCollectionStore((s) => s.productCount)

  const t = useTranslations()

  return (
    <div className='sticky top-28 overflow-y-auto lg:max-h-[calc(100vh-100px)] lg:w-[294px] lg:pr-5'>
      <div className='flex items-center justify-between'>
        <h2 className='font-criteria text-base font-medium leading-6 text-neutral-900'>
          {t('title.filter')}
        </h2>
        <p className='font-sans text-base leading-4.5 text-neutral-500'>
          {t('collection_page.title.count_result', {
            count: productCount || 0,
          })}
        </p>
      </div>
      <Divider className='my-3 mb-0' />
      <FilterList filter={collection.filter} collection={collection} />
    </div>
  )
}
